<app-header></app-header>
<main class="inner_cms_layout about_us_layout">
  <section class="about_us_header">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="about_us_page_header_content">
            <h1>
              <span>CRED BULL</span> India’s Most Trusted and High-Impact Crypto Brand
            </h1>
            <h5>
              CRED BULL is redefining digital finance in India and beyond — merging technology, 
              transparency, and real-world utility to power the future of crypto.
            </h5>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12">
          <div class="text-center">
            <img
              src="assets/images/about_img_01.png"
              class="img-fluid"
              alt="Token"
            />
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <h5 class="about_subtitle">CREDBULL EXCHANGE</h5>
          <h2 class="about_maintitle">
            India’s Crypto Engine
          </h2>
          <p class= "about_description">
            Credbull Exchange is a high-performance cryptocurrency exchange created to power the next generation of digital finance in India and globally. We provide a secure, intuitive platform for trading top crypto assets,
            while integrating real-world utility, auto-trading bots, and fast execution. Designed for everyday users and pro traders alike, CredBull is built to lead the future of crypto with trust, technology, and innovation.         </p>
          <!-- <ul class="about_sec_list">
            <li>Nunc pretium orci non lobortis semper.</li>
            <li>Phasellus in arcu vel quam volutpat.</li>
            <li>Curabitur fringilla tellus et odio mattis.</li>
          </ul> -->
        </div>
      </div>
    </div>
  </section>

  <section class="section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12">
          <h5 class="about_subtitle">Features</h5>
          <h2 class="about_maintitle">
            Why Choose <span>CREDBULL</span> Exchange
          </h2>          
          <div class="feature_list">
            <div class="feature_list_row">
              <img
                src="assets/images/feature_icon_01.png"
                class="img-fluid"
                alt="Token"
              />
              <div>
                <h4>Utility</h4>
                <p>
                  CredBull is the first Indian exchange to offer direct crypto payments for real-world services. Users can instantly use their tokens for flight and hotel bookings, mobile and DTH recharges,
                  utility bills, FASTag, and more—turning crypto into a practical tool for everyday life.                </p>
              </div>
            </div>
            <div class="feature_list_row">
              <img
                src="assets/images/feature_icon_02.png"
                class="img-fluid"
                alt="Token"
              />
              <div>
                <h4>Advanced Auto-Trading Bots</h4>
                <p>
             Maximize your profits with our built-in Spot Trading Bots, including DCA (Dollar-Cost Averaging) and GRID strategies. These tools help automate trades, 
             reduce risk, and optimize entry/exit points—perfect for both passive investors and advanced traders.              </div>
            </div>
            <div class="feature_list_row">
              <img
                src="assets/images/feature_icon_03.png"
                class="img-fluid"
                alt="Token"
              />
              <div>
                <h4>24/7 Customer Support</h4>
                <p>
                 CredBull offers real, human support—anytime you need it. Our dedicated team is available 24/7 via chat, email, and direct phone calls to quickly resolve issues, answer questions, and ensure a smooth,
                 stress-free trading experience. We don’t just respond—we guide, solve, and support every step of the way.                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="text-center">
            <img
              src="assets/images/about_img_02.png"
              class="img-fluid"
              alt="Token"
            />
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section laptop_section">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <img
            src="assets/images/about_img_03.png"
            class="img-fluid"
            alt="Token"
          />
        </div>
      </div>
    </div>
  </section>

  <section class="section pt-0">
    <div class="container">
      <div class="row">
        <div class="col-md-8 m-auto text-center">
          <h2 class="about_maintitle">
            <span>Experience Crypto the Way It Should Be</span>
          </h2>
          <p>
            CredBull is not just another crypto exchange — it’s a complete ecosystem built for real utility, seamless trading, and long-term impact.
             Whether you're a trader or a token founder, you gain access to advanced tools, utility-based spending, and a frictionless trading environment. We’re breaking barriers between crypto and real-world use.          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- <section class="section top_features_section">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h2 class="about_maintitle">Sed pulvinar</h2>
        </div>
        <div class="col-md-4">
          <div class="feature_list_row">
            <img
              src="assets/images/feature_icon_01.png"
              class="img-fluid"
              alt="Token"
            />
            <div>
              <h4>Morbi</h4>
              <p>
                Quis ipsum suspendisse ultrices gravida. Risus commodo viverra
                maecenas accumsan lacus vel facilisis.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="feature_list_row">
            <img
              src="assets/images/feature_icon_02.png"
              class="img-fluid"
              alt="Token"
            />
            <div>
              <h4>Vestibulum</h4>
              <p>
                Quis ipsum suspendisse ultrices gravida. Risus commodo viverra
                maecenas accumsan lacus vel facilisis.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="feature_list_row">
            <img
              src="assets/images/feature_icon_03.png"
              class="img-fluid"
              alt="Token"
            />
            <div>
              <h4>Quisque</h4>
              <p>
                Quis ipsum suspendisse ultrices gravida. Risus commodo viverra
                maecenas accumsan lacus vel facilisis.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> -->
</main>
<app-footer></app-footer>
